module.exports = "https://cdn.realtymogul.com/static/media/logo_stacked_black.c94c61d2.svg";